import { all, takeEvery } from 'redux-saga/effects';
import actions from './actions';
import CollectionSagas from '../Collection/sagas';

class Shops extends CollectionSagas {

    constructor() {
        super(actions,'shops', ['partner']);
    }
}

export default function* rootSaga() {
    yield all([
        takeEvery(actions.LOAD_FROM_FIRESTORE, new Shops().loadFromFirestore),
        takeEvery(actions.SAVE_INTO_FIRESTORE, new Shops().storeIntoFirestore),
    ]);
}
